<ll-titulo>Videoteca</ll-titulo>
<ll-subtitulo>{{ asignatura?.asignatura }}</ll-subtitulo>

<loading-layout #innerContent>
    <menu-asignaturas-horizontal
        *ngIf="asignaturaIds"
        [asignaturaId]="asignaturaId"
        [asignaturaIds]="asignaturaIds"
        [tipoEvaluacion]="evaluacionTipo"
        [enableResponsive]="enableResponsive"
        (asignaturaChanged)="onChangeAsignatura($event)"
    ></menu-asignaturas-horizontal>
    <div (window:resize)="onResize($event)" [class.enableResponsive]="enableResponsive" class="biblioteca">
        <materiales-with-thumbnails
            [tipoMaterial]="materialTipoId"
            [enableModal]="false"
            [asignaturaId]="asignaturaId"
            (onReady)="onReady($event)"
        ></materiales-with-thumbnails>
        <div class="sin-asignatura" *ngIf="!asignaturaId">
            <p>Selecciona una asignatura para ver el material disponible en nuestra biblioteca.</p>
        </div>
    </div>
</loading-layout>
